import React from 'react'
import {Form, InputNumber} from 'antd'

const BInputNumber = ({label, fieldName, rules, placeholder, Icon, formatter, parser, disabled, required, style, white, hidden, min, max, step}) => (
  <div className='bInput bInputNumber' style={{display: hidden ? 'none' : undefined}}>
    {label && <label className='bInputLabel' htmlFor={fieldName}>{label}</label>}
    <div style={style} className={'bInputDiv' + (white ? ' white' : '')}>
      {Icon}
      <Form.Item
        name={fieldName}
        rules={rules ?? (
          required ? [
            {required: true, message: 'This field is required'},
          ] : []
        )}
      >
        <InputNumber
          id={fieldName}
          formatter={formatter}
          parser={parser}
          disabled={disabled}
          min={min}
          max={max}
          step={step}
          placeholder={placeholder ?? (placeholder !== false ? label : '')}
        />
      </Form.Item>
    </div>
  </div>
)

export default BInputNumber
